import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { purple, green, red, blue, indigo, teal, grey } from '@material-ui/core/colors';
import CustomButton from './CustomButton';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Identity() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Box my={8}>
            <Grid spacing={4} container direction="row" justify="center">
              <Grid item xs={8} sm={6} md={5} lg={4}>
                <img src="./images/declare.png" class="img-fluid" />
              </Grid>
            </Grid>
          </Box>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北
          </Typography>
          　1945年12月、デーリー東北は戦後の荒廃の中から力強く産声を上げました。以来、「自由と正義と民主主義」をジャーナリズムの旗印に、北奥羽地域に住む人たちの豊かな生活のため、地域に寄り添い、地域に愛されながら、「地域づくりのパートナー」として歩んでまいりました。いま、時代の空気はそのころとよく似ています。混沌とした時代に、私たちが地域のために何ができるかを考えながら、私たちならではの新たな価値を生み出し、地域の皆さまとともに未来に向けて歩み続けます。
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北の理念
          </Typography>
          <dl>
            <dt>自由と正義と民主主義の精神で</dt>
            <dd>
              言論、報道を通じ、常に誠実で物事の真実に迫る努力を重ね、健全な新聞ジャーナリズムのさらなる発展にまい進します。
            </dd>
            <dt>新たな価値の創造へ</dt>
            <dd>
                地域の皆さまとの信頼関係を礎に、常に変革と創造に挑戦し、独自性に富んだ新たな企業価値を生み出します。
            </dd>
            <dt>北奥羽を豊かに</dt>
            <dd>
              自ら の公共的使命を自覚し、地域の皆さまの期待に応え、手を携えて北奥羽地域の豊かな郷土づくりに貢献します。
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            私たちが大切にするもの
          </Typography>
          <dl>
            <dt>未来に挑戦</dt>
            <dd>
              私たちは前例のない難しい時代と向き合っています。だからといって、リスクや失敗を恐れていては前には進めません。常にチャレンジャーであり続け、新たな未来に挑戦します。
            </dd>
            <dt>本物の価値</dt>
            <dd>
              今ほど本物が求められる時代はありません。私たちは常に新しいものを取り入れる意欲的な姿勢と深い洞察力を持ち、地域の皆さまが真に求める本物の価値を追求します。
            </dd>
            <dt>地域の絆</dt>
            <dd>
              世界で社会の分断が表面化しています。私たちは、地域やそこに暮らす人々のつながりを一番大事にします。地域の皆さまの心をつなぐ絆となり、地域とともに前進します。
            </dd>
            <dt>多様性の力</dt>
            <dd>
              私たちは多様性の持つ力を信じます。それぞれの個性や価値観を尊重し、一人ひとりが成長できる魅力的で楽しい、活力あふれる企業を目指します。
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            後援願い
          </Typography>
          　後援を希望する方は、下記の申請書をダウンロードしていただき、必要事項を記入してください。<br/>
          　申請には、下記の書類が必要です。<br/>
          <ul>
            <li>所定の申請書（下記よりダウンロード、もしくはデーリー東北本社にあります）</li>
            <li>イベント詳細資料（企画書など）</li>
          </ul>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/flyer" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  後援願い用紙
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          　後援承諾書は、１週間以内に、連絡先のＦＡＸ番号へお届けします。<br/>
          　なお、後援承諾書原本が必要な場合は、84円切手を貼付した返信用封筒を申請書と一緒に提出してください。<br/>
          　イベントの入場料金が1,000円を超える場合は、予算書の添付をお願いします。<br/>
          <br/>
          　ポスター・チラシなどに名義を記載した場合は、下記担当部署までお送りください。<br/>
          　また、イベントが終了したら、実施報告書のご提出をお願いいたします。（定型はありません）<br/>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>株式会社デーリー東北新聞社　企画総務局総務部</dt>
            <dd>
              〒031-8601 青森県八戸市城下一丁目３−１２<br/>
              <PhoneEnabledIcon /> 0178-44-5111<br/>
              <i className="fas fa-fax mx-1"></i> 0178-47-0841<br/>
              ※受付時間　午前10時00分～午後５時00分（平日のみ）<br/>
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default Identity;
